<page-toolbar [pageActions]="pageActions" [subtitle]="subtitle" [title]="title"></page-toolbar>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<page-content *ngIf="!isLoading && !!legacyComposition">
  <mat-card appearance="outlined">
    <mat-card-title>Details</mat-card-title>
    <table>
      <tr>
        <td>Title:</td>
        <td>{{legacyComposition.title}}</td>
      </tr>
      <tr>
        <td>Name:</td>
        <td>{{legacyComposition.name}}</td>
      </tr>
      <tr>
        <td>Description:</td>
        <td>{{legacyComposition.description}}</td>
      </tr>
      <tr>
        <td>Id:</td>
        <td>{{legacyComposition._id}}</td>
      </tr>
      <tr>
        <td>Created:</td>
        <td>{{legacyComposition.created | date:'dd MMMM yyyy'}}</td>
      </tr>
      <tr>
        <td>Updated:</td>
        <td>{{legacyComposition.updated | date:'dd MMMM yyyy'}}</td>
      </tr>
      <tr>
        <td>CompositionNames:</td>
        <td>{{legacyComposition.compositionNames}}</td>
      </tr>
    </table>
  </mat-card>
  <div class="spacer"></div>


  <div class="spacer"></div>

  <div class="split-wrapper">

    <ng-container *ifPrivilege="{name: 'read', value: 'imports'}">
      <mat-card appearance="outlined" *ngIf="importIdsInfo[0].id" class="split">
        <mat-card-title>Imports:</mat-card-title>
        <ng-container *ngFor="let entry of importIdsInfo;">
          <mat-expansion-panel *ngIf="entry">
            <mat-expansion-panel-header>
              <mat-panel-title> {{entry.name}}, Type: {{entry.importType}}</mat-panel-title>
              <mat-panel-description></mat-panel-description>
            </mat-expansion-panel-header>

            <ng-container *ngIf="entry.properties">
              <mat-list-item *ngIf="entry.properties['Main App Item Id']">Import App ID
                : {{entry.properties['Main App Item Id']}}</mat-list-item>
              <mat-list-item *ngIf="entry.properties['Main Widget Item Id']">Import Widget ID
                : {{entry.properties['Main Widget Item Id']}}</mat-list-item>
              <mat-list-item *ngIf="entry.properties['MenuItem id']">Import Menu Item (Menu)
                : {{entry.properties['MenuItem id']}}</mat-list-item>
              <mat-list-item *ngIf="entry.properties['MenuEntry id']">Import Menu Entry (Widget preview)
                : {{entry.properties['MenuEntry id']}}</mat-list-item>
              <mat-list-item *ngIf="entry.properties['Menu Item Id']">Import Menu Item (App)
                : {{entry.properties['Menu Item Id']}}</mat-list-item>
              <mat-list-item *ngIf="entry.properties['Menu Entry Id']">Import Menu Entry (Widget preview)
                : {{entry.properties['Menu Entry Id']}}</mat-list-item>
            </ng-container>

            <ng-container *ngFor="let item of entry.assignable">
              <mat-list-item>Assignable Item Title: {{item.title}}</mat-list-item>
              <mat-list-item>Assignable Item Id: {{item.menuItemId}}</mat-list-item>
            </ng-container>

            <mat-list-item>
              <button mat-button>
                <a [routerLink]=entry.url class="default">Go to Importer</a>
              </button>
            </mat-list-item>

            <mat-list-item *ngIf="entry.fetchLog">
              <button mat-button>Fetch From Log Data</button>
            </mat-list-item>

          </mat-expansion-panel>
        </ng-container>
      </mat-card>
      <mat-card appearance="outlined" *ngIf="!importIdsInfo[0].id" class="split">
        <mat-card-title>Imports:</mat-card-title>
        <p>{{importIdsInfo[0].title}}</p>
      </mat-card>
    </ng-container>
    <ng-container *ifPrivilege="{name: 'read', value: 'code-snippets'}">
      <mat-card appearance="outlined" class="split">
        <mat-card-title>Code Snippets:</mat-card-title>
        <table *ngIf="codeSnippetInfo[0].id">

          <ng-container *ngFor="let info of codeSnippetInfo; let i = index">
            <tr *ngIf="info">
              <td>{{i + 1}}:</td>
              <td>
                <a [routerLink]=info.url class="default">
                  <i class="material-icons">link</i>
                  <ng-container *ngIf="info.title">{{info.title}}</ng-container>
                  <ng-container *ngIf="!info.title">{{info.id}}</ng-container>
                  <ng-container *ngIf="info.error">{{info.error}}</ng-container>
                </a>
              </td>
            </tr>
          </ng-container>
        </table>
        <p *ngIf="!codeSnippetInfo[0].id">{{codeSnippetInfo[0].title}}</p>
      </mat-card>
    </ng-container>
  </div>

</page-content>

